import CustomTable from "../../core/custom-table";
import { trainingCertificateList } from "./helper";

const TrainingEnrollmentCertificate = () => {
    const certificateList = [];

    return (
        <>
             <div className="training-certificate-list-container">
                <div className="title-container">
                    <span className="training-title">Training</span> 
                    <div className="list-title">Enrollment List</div>
                </div>               
                <div className="list-container">
                <CustomTable
                    header={trainingCertificateList.HeaderConfig}
                    data={certificateList || []}
                    //pageCount={pastTickets.totalPages}
                    //onClick={onRowClick}
                    //filters={filters}
                    /* onChange={(page) => {
                        setFilters({
                        ...filters,
                        page,
                        }); */
                        /* loadData({
                        ...filters,
                        page,
                        }); */
                    //}}
                    />
                </div>
            </div>
        </>
    )
};

export default TrainingEnrollmentCertificate;